// The Workers' Comp wizard's field grids, shared by each step and its Review
// (BRK-S349), so a value on Review sits where its field sits on its step.

/** Two columns from sm: the insured, a person, a contact, building details. */
export const TWO_COLUMNS = "grid grid-cols-1 gap-4 sm:grid-cols-2";

/** A payroll row's counts and payroll, three across from sm. */
export const THREE_COLUMNS = "grid grid-cols-1 gap-4 sm:grid-cols-3";

/** An address's parts, two by two from sm, as `AddressFieldset` lays them. */
export const ADDRESS_COLUMNS = "grid grid-cols-1 gap-3 sm:grid-cols-2";

/** The questions, two columns from md, not sm: at sm a column is ~290px, too
 *  tight for a Yes/No and its ACORD help; at md it is ~350px (BRK-S345). */
export const QUESTION_COLUMNS =
  "grid grid-cols-1 items-start gap-4 md:grid-cols-2 md:gap-x-8";
